var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoInterestEvent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "15px",
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNoInterestEvent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.09374052,7.36 C2.8543061,7.36 1.84018902,6.44798965 1.84,5.33317812 L1.84,4.32665188 C1.84,3.21201035 2.8543061,2.3 4.09374052,2.3 L4.64625948,2.3 C5.88588292,2.3 6.9,3.21201035 6.9,4.32665188 L6.9,5.33317812 C6.9,6.44798965 5.8856939,7.36 4.64625948,7.36 L4.09374052,7.36 Z M11.8635115,5.98 C10.3987254,5.98 9.20022339,4.90216959 9.2,3.58466505 L9.2,2.39513405 C9.2,1.07783041 10.3987254,0 11.8635115,0 L12.5164885,0 C13.981498,0 15.18,1.07783041 15.18,2.39513405 L15.18,3.58466505 C15.18,4.90216959 13.9812746,5.98 12.5164885,5.98 L11.8635115,5.98 Z M6.99862186,8.38266601 C6.64765359,8.79908363 6.44,9.31346296 6.44,9.86949489 L6.44,13.34 L0.583532114,13.34 C0.261227715,13.34 0,13.0884509 0,12.7780881 L0,10.1202963 C0,9.10556506 0.8573297,8.28 1.91094278,8.28 L6.36873492,8.28 C6.58932982,8.28 6.80131163,8.31616715 6.99862186,8.38266601 Z M14.7901907,7.36 C16.019782,7.36 17.02,8.48577054 17.02,9.86949489 L17.02,13.4937566 C17.02,13.9169786 16.7152343,14.26 16.3392125,14.26 L8.04078747,14.26 C7.66476567,14.26 7.36,13.9169786 7.36,13.4937566 L7.36,9.86949489 C7.36,8.48577054 8.36021798,7.36 9.58943324,7.36 L14.7901907,7.36 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icNoInterestEvent",
    fill: "#333333",
    fillRule: "nonzero",
    opacity: 0.4,
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoInterestEvent);
export default __webpack_public_path__ + "static/media/icNoInterestEvent.7e434e31e2dbdf5a4a527ca465ce3619.svg";
export { ForwardRef as ReactComponent };